export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/680273bf09bfd3a8fc34474ae0d0eb37.svg";